import React, { Component } from "react";
import PropTypes from "prop-types";

class CheckboxGroup extends Component {
  constructor(props) {
    super(props);

    this._handleClick = this._handleClick.bind(this);
  }

  _isCheckboxChecked(checkedValues, value) {
    return checkedValues.indexOf(value) >= 0;
  }

  _handleClick(e) {
    const { value, checked: isChecked } = e.target;
    const { checked, onChangeHandler } = this.props;

    if (isChecked) {
      const newChecked = checked.concat(value);
      onChangeHandler(newChecked);
    } else {
      const newChecked = checked.filter(v => v !== value);
      onChangeHandler(newChecked);
    }
  }

  render() {
    const { checked, children } = this.props;

    return React.Children.map(children, child => {
      return React.cloneElement(child, {
        isChecked: this._isCheckboxChecked(checked, child.props.value),
        handleClick: this._handleClick
      });
    });
  }
}

CheckboxGroup.propTypes = {
  checked: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  onChangeHandler: PropTypes.func
};

export default CheckboxGroup;



// WEBPACK FOOTER //
// ./src/components/form/CheckboxGroup.js